/**
 * @flow
 * @relayHash fb3b2bbb44371cf38d8c644380506f54
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OverrideReportPageCSVQueryVariables = {||};
export type OverrideReportPageCSVQueryResponse = {|
  +overrideReportCsv: ?{|
    +taskId: ?string
  |}
|};
export type OverrideReportPageCSVQuery = {|
  variables: OverrideReportPageCSVQueryVariables,
  response: OverrideReportPageCSVQueryResponse,
|};
*/


/*
query OverrideReportPageCSVQuery {
  overrideReportCsv {
    taskId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "overrideReportCsv",
    "storageKey": null,
    "args": null,
    "concreteType": "CSVTaskResult",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "taskId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "OverrideReportPageCSVQuery",
  "id": "ea1af0ef9c71ee0d9870e1cd23c29c54",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "OverrideReportPageCSVQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v0
  },
  "operation": {
    "kind": "Operation",
    "name": "OverrideReportPageCSVQuery",
    "argumentDefinitions": [],
    "selections": v0
  }
};
})();
node.text = "query OverrideReportPageCSVQuery {\n  overrideReportCsv {\n    taskId\n  }\n}\n";
(node/*: any*/).hash = '1daa077284ae314e9880172be8ffaba4';
module.exports = node;
